import { render, staticRenderFns } from "./ModalCustomers.vue?vue&type=template&id=31af16cf&lang=pug&"
import script from "./ModalCustomers.vue?vue&type=script&lang=js&"
export * from "./ModalCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports